/*
 * Header arama önerileri — snippets/header-search.liquid.
 *
 * Arama paneli açıldığında, kutu boşken header'daki "Arama önerisi" bloklarını gösterir;
 * yazmaya başlanınca gizler, kutu boşalınca geri getirir. Sonuçları xCloud Search kendi
 * dropdown'unda gösteriyor, ona dokunulmuyor.
 *
 * Odağa bağlı DEĞİL: tema dokunmatik cihazlarda arama açılınca input'a odaklanmıyor
 * (theme.js → DialogElement initialFocus), öneriler yine de görünmeli.
 */
(() => {
  if (window.customElements.get('hp-search-suggestions')) return;

  class HpSearchSuggestions extends HTMLElement {
    #listeners;

    connectedCallback() {
      const search = this.closest('header-search');
      if (!search) return;

      this.#listeners = new AbortController();
      const { signal } = this.#listeners;
      const update = () => this.#update(search.querySelector('input[name="q"]'));

      // Dinleyici input'a değil header-search'e: xCloud input'u değiştirse de çalışsın
      search.addEventListener('input', (event) => event.target.name === 'q' && update(), { signal });
      search.addEventListener('reset', () => setTimeout(update), { signal });
      // Geri tuşuyla dönülünce (bfcache) kutuda eski metin kalmış olabilir
      search.addEventListener('dialog:before-show', update, { signal });

      update();
    }

    disconnectedCallback() {
      this.#listeners?.abort();
    }

    #update(input) {
      this.hidden = Boolean(input?.value.trim());
    }
  }

  window.customElements.define('hp-search-suggestions', HpSearchSuggestions);
})();
